import { useCallback } from 'react';
export var useSearchTrigger = function useSearchTrigger(props) {
  var onClick = props.onClick;
  var handleClick = useCallback(function () {
    onClick();
  }, [onClick]);
  return {
    handleClick: handleClick
  };
};